import { render } from "./demo.vue?vue&type=template&id=0c94020e"
import script from "./demo.vue?vue&type=script&lang=tsx"
export * from "./demo.vue?vue&type=script&lang=tsx"
script.render = render

export default script